export default "/images/down-grey-bold.svg?1847b6976503809c7aab965e3b0c8403";